<!-- @format -->
<div
	class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-mt-m hmf-mb-l hmf-mb-m-xxl">
	<ng-container *ngIf="displayButton">
		<hmf-button
			variant="secondary"
			tabindex="0"
			title="Load More Reviews"
			[label]="label"
			[text]="label"
			[size]="isMobileSize() ? 'small' : 'medium'"
			[disabled]="disabled"
			(click)="loadMoreReviews()"
			(keydown.enter)="loadMoreReviews()"></hmf-button>
	</ng-container>

	<p class="hmf-mt-xs hmf-mb-0 hmf-subheader-s-s hmf-subheader-m-m">
		Viewing {{ remain }} of {{ total }}
	</p>
</div>
